import React from "react";
import PropTypes from "prop-types";

import { Label, ContainerIcon } from "./styles";

export const UIComponent = ({ label, icon, style, styleLabel, ...otherProps }) => {
  return (
    <Label title={label} style={styleLabel}>
      {label}
      <input style={style} {...otherProps} />
      <ContainerIcon>{icon}</ContainerIcon>
    </Label>
  );
};

UIComponent.propTypes = {
  label: PropTypes.string,
  icon: PropTypes.element,
  style: PropTypes.object,
  styleLabel: PropTypes.object,
};
